var SpinnerDisplayTextEs = {
  loadingText: 'Cargando'
};

export { SpinnerDisplayTextEs };
